// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._S_tErgt2vykVG0PB_lo {\n    margin-bottom: var(--spacers-dp24);\n    max-width: 480px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/UserAppUpload/CreateOrganisationModal/CreateOrganisationModal.module.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,gBAAgB;AACpB","sourcesContent":[".field {\n    margin-bottom: var(--spacers-dp24);\n    max-width: 480px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"field": "_S_tErgt2vykVG0PB_lo"
};
export default ___CSS_LOADER_EXPORT___;
